import MuiKeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { SvgIconProps } from '@mui/material/SvgIcon';

export type KeyboardArrowDownProps = SvgIconProps;

export const KeyboardArrowDown = (props: KeyboardArrowDownProps) => {
  return <MuiKeyboardArrowDown {...props} />;
};
